export const convertBase64ToFile = base64File => {
  const byteCharacters = atob(base64File);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  var file = new Blob([byteArray], { type: "application/octet-stream; base64" });
  var fileURL = URL.createObjectURL(file);

  return fileURL;
};

export const convertFileToBase64 = (file, callback) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onloadend = () => {
    callback(removeHeadersMimeTypeFromDataUrl(reader.result), file);
  };
};

export const convertBase64ToBlob = (base64, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

export const convertBase64ToObjectUrl = (base64, contentType = '', sliceSize = 512) => {
  const blob = convertBase64ToBlob(base64, contentType, sliceSize);
  return URL.createObjectURL(blob);
}

const removeHeadersMimeTypeFromDataUrl = dataUrl => dataUrl.substring(dataUrl.lastIndexOf(",") + 1);
